import { DAY_PASS_NAME } from '@/messages/constants'

/**
 * Button text
 */
export const BUTTONS = {
  contact: 'Contact Us',
  viewTix: 'View Tickets',
  reschedule: 'Reschedule',
  startOver: 'Start Over',
  soldOut: 'Sold out',
  addToOrder: 'Add to Order',
  updateOrder: 'Update Order',
  continue: 'Continue',
  purchase: 'Place Order',
  delete: 'Remove Tickets',
  backToEvents: 'Back to Events',
  viewAll: 'View All',
  viewMap: 'View Map',
  timedTicketing: 'Timed Ticketing',
  dayPass: DAY_PASS_NAME,
  landingPages: {
    exhibition: 'Exhibit Tickets',
    events: 'Event Tickets',
    exhibitionMobile: 'Exhibit',
    eventsMobile: 'Events',
  },
  dismiss: 'Dismiss',
  reload: 'Reload',
  tryAgain: 'Try Again',
  clearAll: 'Clear all',
  applyPerk: 'Apply Perk',
  applyCoupon: 'Apply Promo or Coupon Code',
  confirmStartOver: 'Yes, Start Over',
  confirmStayHere: 'No, Stay Here',
  confirmLogin: 'Yes, log me in',
  confirmLogout: 'Yes, log me out',
  confirmRemoveTickets: 'Yes, remove tickets',
  buyNow: 'Buy Now',
  noThanks: 'No thanks',
  ariaCloseModal: 'Close Modal',
  ariaDismissNotification: 'Dismiss notification',
  close: 'Close',
  cancel: 'Cancel',
  loading: 'Loading...',
  applying: 'Applying...',
  readMore: 'Read more',
  readLess: 'Read less',
  submit: 'Submit',
  buyTickets: 'Buy tickets',
  showMoreDates: 'Show more dates',
}
